import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Store } from "@ngrx/store";
import {
  fetchPaymentMethod,
  getPaymentMethod,
  updateUserPayout
} from "../../store/payment-method/payment-method.action";
import { getPaymentMethodSelector } from '@store/payment-method/payment-method.selectors';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class PaymentMethodsService {
  backendUrl = environment.backendUrl;

  private _clickSaved = new Subject<boolean>();
  clickSaved$ = this._clickSaved.asObservable();


  constructor(
    private http: HttpClient,
    private store: Store<{ authToken: string }>
  ) {}


  onClickSavedToggle(clicked: boolean) {
    this._clickSaved.next(clicked);
  }

  getPaymentMethodsSelector() {
    return this.store.select(getPaymentMethodSelector); 
  }

  fetchPaymentMethods() {
    this.store.dispatch(fetchPaymentMethod());
  }

  fetchPaymentMethod(id) {
    this.store.dispatch(getPaymentMethod({ id }))
  }

  updateUserPayout(payMethod) {
    this.store.dispatch(updateUserPayout({ payMethod }));
  }

  getPaymentMethods() {
    return this.http.get(`${this.backendUrl}/payments/methods`);
  }

  getPaymentMethod(id: string) {
    return this.http.get(`${this.backendUrl}/payments/methods/${id}`);
  }

  renewUserPayment(payMethod) {
    return this.http.patch(`${this.backendUrl}/payments/requisites`, payMethod)
  }

  
}
